import { Link, LinkProps } from 'react-router-dom';

import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import {
  Box,
  BoxProps,
  Paper,
  PaperProps,
  TextField,
  TextFieldProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export const StyledBox = styled(Box)<BoxProps>({
  padding: '15px 20px',
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
});

export const StyledPaper = styled(Paper)<PaperProps & { theme?: Theme }>(({ theme }) => ({
  width: '444px',
  [theme.breakpoints.down('sm')]: {
    width: '300px',
  },
}));

export const StyledTextField = styled(TextField)<TextFieldProps>({
  margin: '10px 0',
  appearance: 'none',
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
});

export const StyledLoadingButton = styled(LoadingButton)<LoadingButtonProps>({
  padding: '10px 15px',
});

export const StyledLink = styled(Link)<LinkProps & { component?: typeof Link }>(({ theme }) => ({
  color: theme.colors.primary.main,
  fontWeight: 600,
  fontSize: '12px',
  textDecoration: 'none',
  margin: '10px 0',
}));

export const StyledBoldText = styled(Typography)<TypographyProps>({
  fontWeight: 700,
});

export const StyledAreaBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'maxWidth',
})<BoxProps & { theme?: Theme; active?: boolean; maxWidth?: string }>(
  ({ theme, active = false, maxWidth }) => ({
    maxWidth: maxWidth || '580px',
    padding: '24px',
    borderRadius: '12px',
    // Use CSS variables for proper theme support
    backgroundColor: 'var(--sk-surface-default)',
    border: `1px solid ${active ? 'var(--sk-cyan-500)' : 'var(--sk-surface-border)'}`,
    color: 'var(--sk-text-primary)',
    // Ensure MUI Typography inherits proper colors
    '& .MuiTypography-root': {
      color: 'var(--sk-text-primary)',
    },
    '& .MuiTypography-colorTextSecondary': {
      color: 'var(--sk-text-secondary)',
    },
  }),
);

export const StyledOverflowHiddenTypography = styled(Typography)<TypographyProps>({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
});
